module.exports = __webpack_public_path__ + "static/media/event.91b888bf.png";